import { render, staticRenderFns } from "./Ekran.vue?vue&type=template&id=144c6494"
import script from "./Ekran.vue?vue&type=script&lang=js"
export * from "./Ekran.vue?vue&type=script&lang=js"
import style0 from "./Ekran.vue?vue&type=style&index=0&id=144c6494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports